import styled from 'styled-components'

export const PinchZoomBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.98);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
`
export const ContentWrap = styled.div`
  max-width: 95vw;
  max-height: 95vh;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const CloseButton = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;

  border: none;
  background-color: transparent;
  transition:
    color 0.25s ease-in-out,
    color 0.25s ease-in-out;
`
